/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { get, CashRequestOptions, SerializeQueryParameters } from '@cash-web/shared-util-fetch'
import {GetStampsConfigRequest} from '@cash-web/protos/squareup/cash/semaphore/api/SemaphoreCustomerCircumstance.pb'
import {StampsConfig} from '@cash-web/protos/squareup/franklin/common/stamp.pb'


export const getStampsConfig = (params?: SerializeQueryParameters, options?: CashRequestOptions) => get<StampsConfig>("/cash-app/config/stamps-config", params, {...options, rejectOnError: true })